/**
 * @version $Id: dataPackCalendarPeriod.model.ts 54447 2017-07-26 23:34:29Z eduardo.s.neto $
 */
export class DataPackCalendarPeriod {

  public weekDays: string;
  public initialHour: string;
  public endHour: string;
  public initialDate: string;
  public endDate: string;

  public constructor() {

  }
}


// WEBPACK FOOTER //
// ./src/app/models/dataPackCalendarPeriod.model.ts